/**
 * Browser feature detection utilities
 * Used to determine which modern formats the browser supports
 */

let webpSupportCache: boolean | null = null

/**
 * Detects if the browser supports WebP image format
 * Uses canvas-based detection for reliability
 * Result is cached in memory for performance
 *
 * @returns {boolean} True if browser supports WebP, false otherwise
 */
export const checkWebPSupport = (): boolean => {
  // Return cached result if available
  if (webpSupportCache !== null) {
    return webpSupportCache
  }

  // Perform detection using canvas
  try {
    const canvas = document.createElement('canvas')
    if (canvas.getContext && canvas.getContext('2d')) {
      // Check if toDataURL returns a WebP image
      const testResult = canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0
      webpSupportCache = testResult
      return testResult
    }
  } catch (err) {
    // If any error occurs, assume WebP is not supported
    console.warn('WebP detection failed, falling back to legacy format:', err)
    webpSupportCache = false
    return false
  }

  // Default to not supported if canvas is unavailable
  webpSupportCache = false
  return false
}

/**
 * Resets the WebP support cache
 * Useful for testing purposes
 */
export const resetWebPSupportCache = (): void => {
  webpSupportCache = null
}
